import { createContext } from 'react';

type ModalContextProps = {
  showHeaderBorder: boolean;
  showFooterBorder: boolean;
  onClose: () => void;
  onHeaderBorderChange: (value: boolean) => void;
  onFooterBorderChange: (value: boolean) => void;
  isFullScreen: boolean;
};

const ModalContext = createContext<ModalContextProps>({
  showHeaderBorder: false,
  showFooterBorder: false,
  onClose: () => {},
  onHeaderBorderChange: () => {},
  onFooterBorderChange: () => {},
  isFullScreen: false,
});

export default ModalContext;
